<p>
  other-settings works!
</p>
